import { useContext } from 'react';
import { EMPTY_OBJECT, AppContext } from 'commons-ui';

import useService from '../utils/useService';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT, setForceUpdateRows, setConfirmationDialog } = params;
	const {
		app: { appName }
	} = useContext(AppContext);
	const { requestDeleteSchema } = useService();
	switch (action.id) {
		case 'add':
			return () => {
				history.push({
					pathname: `/dashboard/mttSchema/create`
				});
			};
		case 'edit':
			return () => {
				history.push({
					pathname: '/dashboard/mttSchema/edit',
					state: {
						rowData
					}
				});
			};

		case 'back':
			return () => {
				history.push({
					pathname: '/dashboard/mttSchema/list'
				});
			};

		case 'delete': {
			const deleteMttSchemaData = async () => {
				await requestDeleteSchema(appName, rowData);
				setForceUpdateRows(true);
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Remove this mtt schema?',
					handleAlertConfirmation: deleteMttSchemaData
				});
			};
		}
		case 'uploadCsv':
			return () => {
				history.push({
					pathname: `/dashboard/mttSchema/uploadCsv`
				});
			};

		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
